import Middleware from './middleware'
import { Auth, authMiddleware, ExpiredAuthSessionError } from '~auth/runtime'

// Active schemes
import { Oauth2Scheme } from '~auth/runtime'

Middleware.auth = authMiddleware

export default function (ctx, inject) {
  // Options
  const options = {
  "resetOnError": false,
  "ignoreExceptions": false,
  "scopeKey": "scope",
  "rewriteRedirects": true,
  "fullPathRedirect": false,
  "watchLoggedIn": true,
  "redirect": {
    "login": "/login",
    "logout": "/",
    "home": "/",
    "callback": "/login"
  },
  "vuex": {
    "namespace": "auth"
  },
  "cookie": {
    "prefix": "auth.",
    "options": {
      "path": "/"
    }
  },
  "localStorage": {
    "prefix": "auth."
  },
  "defaultStrategy": "awsCognito"
}

  // Create a new Auth instance
  const $auth = new Auth(ctx, options)

  // Register strategies
  // awsCognito
  $auth.registerStrategy('awsCognito', new Oauth2Scheme($auth, {
  "endpoints": {
    "authorization": "https://preusedev.auth.us-east-1.amazoncognito.com/login",
    "token": "https://preusedev.auth.us-east-1.amazoncognito.com/oauth2/token",
    "userInfo": "https://preusedev.auth.us-east-1.amazoncognito.com/oauth2/userInfo",
    "logout": "https://preusedev.auth.us-east-1.amazoncognito.com/logout"
  },
  "token": {
    "property": "access_token",
    "type": "Bearer",
    "maxAge": 3600
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "token",
  "redirectUri": "https://preusedev.com/login",
  "logoutRedirectUri": "https://preusedev.com/",
  "clientId": "7mhc0fin41g3qe09nn0piish21",
  "scope": [
    "email",
    "openid",
    "profile",
    "aws.cognito.signin.user.admin"
  ],
  "codeChallengeMethod": "S256",
  "name": "awsCognito"
}))

  // Inject it to nuxt context as $auth
  inject('auth', $auth)
  ctx.$auth = $auth

  // Initialize auth
  return $auth.init().catch(error => {
    if (process.client) {
      // Don't console log expired auth session errors. This error is common, and expected to happen.
      // The error happens whenever the user does an ssr request (reload/initial navigation) with an expired refresh
      // token. We don't want to log this as an error.
      if (error instanceof ExpiredAuthSessionError) {
        return
      }

      console.error('[ERROR] [AUTH]', error)
    }
  })
}
